import React from "react";
import SidebarTenagaKesehatan from "../../components/SidebarTenagaKesehatan";
import TopBarDetailPasien from "../../components/TobBarDetailPasien";
import DetailPasienTK from "../../components/DetailPasienTK";
import "../../CSS/SemuaDataPasienTK.css";

function HalamanDataPasienTenagaKesehatan() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarTenagaKesehatan />

      {/* Area kanan */}
      <div className="content">
        <TopBarDetailPasien />

        {/* Konten utama */}
        <div className="main-content-pasien">
          <DetailPasienTK />
        </div>
      </div>
    </div>
  );
}

export default HalamanDataPasienTenagaKesehatan;
